module.exports = __webpack_public_path__ + "img/bundle-green-2.47e048d.webp";